import { createSelector } from 'reselect'

const getAccount = (state) => state.account

export const isLoggedIn = createSelector(
  getAccount,
  (account) => !!account?.uuid
)
